(function () {
  'use strict';

  const raw = window.__charmData;
  if (!raw) return;

  const CHARM_TAG    = 'italian-charm';
  const CAT_PREFIX   = 'charm-cat:';
  const SLOTS_PREFIX = 'charm-slots:';

  // charm-slots:N タグからスロット数を取得
  const allCharms = raw.charms
    .filter(p => Array.isArray(p.tags) && p.tags.includes(CHARM_TAG))
    .map(p => {
      const t = p.tags.find(t => t.startsWith(SLOTS_PREFIX));
      return { ...p, slots: t ? parseInt(t.replace(SLOTS_PREFIX, '')) : 1 };
    });

  let slots   = [];
  let currentSize = 0;
  let activeCategory = 'all';
  let sortable = null;
  let mobileSlotPx = 54; // JSで動的更新される

  const el = id => document.getElementById(id);
  const dom = {
    sizes:      el('cs-sizes'),
    bracelet:   el('cs-bracelet'),
    countLabel: el('cs-count-label'),
    reset:      el('cs-reset'),
    cartBar:    el('cs-cart-bar'),
    cartBtn:    el('cs-cart-btn'),
    cats:       el('cs-cats'),
    catalog:        el('cs-catalog'),
    overviewBtn:    el('cs-overview-btn'),
    overviewModal:  el('cs-overview-modal'),
    overviewScroll: el('cs-overview-scroll'),
    overviewClose:  el('cs-overview-close'),
    overviewBd:     el('cs-overview-bd'),
  };

  /* ── サイズ ─────────────────────────── */

  function renderSizes() {
    dom.sizes.innerHTML = raw.sizes.map((s, i) =>
      `<button class="cs-size-btn" data-i="${i}" data-tooltip="手首周り${s.wrist}の方におすすめ">
        ${s.label}
        <span class="cs-size-count">${s.count}個</span>
      </button>`
    ).join('');

    dom.sizes.querySelectorAll('.cs-size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        dom.sizes.querySelectorAll('.cs-size-btn').forEach(b => b.classList.remove('cs-size-btn--active'));
        btn.classList.add('cs-size-btn--active');
        applySize(raw.sizes[+btn.dataset.i].count);
      });
    });

    dom.sizes.querySelector('.cs-size-btn').click();
  }

  function applySize(n) {
    currentSize = n;
    const placements = getPlacedCharms();
    slots = Array(n).fill(null);
    let idx = 0;
    for (const charm of placements) {
      const cn = charm.slots;
      if (idx + cn <= n) {
        for (let i = 0; i < cn; i++) slots[idx + i] = charm;
        idx += cn;
      } else break;
    }
    renderBracelet();
    updateMeta();
  }

  /* ── ダングルスケール ────────────────── */

  function getCwPct(imageUrl) {
    const m = imageUrl.match(/_cwp(\d+)/);
    return m ? parseInt(m[1]) : null;
  }

  function getCytPct(imageUrl) {
    const m = imageUrl.match(/_cyt(\d+)/);
    return m ? parseInt(m[1]) : null;
  }

  function getWcxPct(imageUrl) {
    const m = imageUrl.match(/_wcx(\d+)/);
    return m ? parseInt(m[1]) : null;
  }

  function getWcy1Pct(imageUrl) {
    const m = imageUrl.match(/_wcy1(\d+)/);
    return m ? parseInt(m[1]) : null;
  }

  function getWcy2Pct(imageUrl) {
    const m = imageUrl.match(/_wcy2(\d+)/);
    return m ? parseInt(m[1]) : null;
  }

  function applyDangleScale(imgEl, charm) {
    const cwPct = getCwPct(charm.image);
    if (cwPct === null) return;

    const slotPx = window.matchMedia('(max-width: 749px)').matches ? mobileSlotPx : 72;
    const cytPct = getCytPct(charm.image);

    const apply = () => {
      if (!imgEl.naturalWidth) return;
      const connectorPx = imgEl.naturalWidth * cwPct / 100;
      const scale       = slotPx / connectorPx;
      const dispW       = imgEl.naturalWidth  * scale;
      const dispH       = imgEl.naturalHeight * scale;
      imgEl.style.width  = dispW + 'px';
      imgEl.style.height = dispH + 'px';
      imgEl.style.left   = ((slotPx - dispW) / 2) + 'px';
      // ダングル(_cytあり): 選択矩形の横中心をスロット中心線(y=slotPx/2)に揃える
      // それ以外(ベーシック等): 画像中心をスロット中心線に揃える
      const isDangle = charm.tags.some(t => t.trim() === CAT_PREFIX + 'ダングル');
      imgEl.style.top = (isDangle && cytPct !== null)
        ? (slotPx / 2 - imgEl.naturalHeight * cytPct / 100 * scale) + 'px'
        : ((slotPx - dispH) / 2) + 'px';
    };

    if (imgEl.complete && imgEl.naturalWidth > 0) apply();
    else imgEl.addEventListener('load', apply, { once: true });
  }

  /* ── ウォッチ位置調整 ────────────────── */

  function applyWatchPosition(imgEl, charm) {
    const wcxPct  = getWcxPct(charm.image);
    if (wcxPct === null) return; // CSSデフォルト (top: -180px / -135px) を使用

    const wcy1Pct = getWcy1Pct(charm.image);
    const wcy2Pct = getWcy2Pct(charm.image);
    const isMobile   = window.matchMedia('(max-width: 749px)').matches;
    const slotPx     = isMobile ? mobileSlotPx : 72;
    const watchWidth = slotPx * 6;

    // _wcy1/_wcy2 があればコネクタが両端ぴったりになるよう cssH と left を計算
    // ない場合は watchWidth をそのまま使い、画像中心をスロット中央に置く
    let cssH, left;
    if (wcy1Pct !== null && wcy2Pct !== null) {
      const spanPct = (wcy2Pct - wcy1Pct) / 100;
      cssH = spanPct > 0 ? watchWidth / spanPct : watchWidth;
      left = cssH * (0.5 - wcy1Pct / 100);
    } else {
      cssH = watchWidth;
      left = watchWidth / 2;
    }

    const apply = () => {
      if (!imgEl.naturalWidth) return;
      // width:auto なので cssW は自然縦横比から計算
      const cssW = imgEl.naturalWidth / imgEl.naturalHeight * cssH;
      // 回転後: wcxPct がスロット中心線 (slotPx/2) に来るよう top を計算
      const top  = slotPx / 2 - cssH / 2 - cssW / 2 + wcxPct / 100 * cssW;
      imgEl.style.height = cssH + 'px';
      imgEl.style.left   = left + 'px';
      imgEl.style.top    = top + 'px';
    };

    if (imgEl.complete && imgEl.naturalWidth > 0) apply();
    else imgEl.addEventListener('load', apply, { once: true });
  }

  /* ── ブレスレット ────────────────────── */

  function renderBracelet() {
    updateMobileSlotSize();
    if (sortable) { sortable.destroy(); sortable = null; }

    // 配置済みチャームを順序通りに取得し、slots を左詰めで再構築
    const placed = getPlacedCharms();
    slots = Array(currentSize).fill(null);
    let idx = 0;
    for (const c of placed) {
      for (let k = 0; k < c.slots && idx + k < currentSize; k++) slots[idx + k] = c;
      idx += c.slots;
    }

    // placed リストから直接 HTML を生成（slots 配列のポジションに依存しない）
    const html = [];
    for (const charm of placed) {
      const n = charm.slots;
      const multiClass = n > 1 ? ` cs-slot--multi-${n}` : '';
      const dangleClass = charm.tags.some(t => t.trim() === CAT_PREFIX + 'ダングル') ? ' cs-slot--dangle' : '';
      html.push(
        `<div class="cs-slot cs-slot--filled${multiClass}${dangleClass}" data-charm-id="${charm.id}" data-slots="${n}">
          <img src="${charm.image}" alt="${charm.title}">
          <button class="cs-slot-remove" aria-label="削除">×</button>
        </div>`
      );
    }
    const usedSlots = placed.reduce((sum, c) => sum + c.slots, 0);
    for (let i = usedSlots; i < currentSize; i++) {
      html.push(`<div class="cs-slot cs-slot--empty"><span class="cs-slot-plus">+</span></div>`);
    }

    dom.bracelet.innerHTML = html.join('');

    dom.bracelet.querySelectorAll('.cs-slot-remove').forEach(btn => {
      btn.addEventListener('click', e => {
        e.stopPropagation();
        removeCharmFromSlot(btn.closest('.cs-slot'));
      });
    });

    dom.bracelet.querySelectorAll('.cs-slot--filled').forEach(slotEl => {
      const id = slotEl.dataset.charmId;
      const charm = allCharms.find(c => String(c.id) === id);
      if (!charm) return;
      if (charm.slots === 6) {
        applyWatchPosition(slotEl.querySelector('img'), charm);
      } else if (getCwPct(charm.image) !== null) {
        applyDangleScale(slotEl.querySelector('img'), charm);
      }
    });

    if (window.Sortable) {
      sortable = Sortable.create(dom.bracelet, {
        animation: 150,
        ghostClass: 'cs-slot--ghost',
        onEnd() { syncFromDOM(); compactSlots(); setTimeout(() => { renderBracelet(); updateMeta(); }, 0); }
      });
    }

    applyBraceletZoom();
  }

  /* ── ブレスレット縮小表示 ────────────── */

  /* ── モバイルスロットサイズ動的計算 ───── */

  function updateMobileSlotSize() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const scrollEl = dom.bracelet.parentElement;
    const availW   = scrollEl.clientWidth - 32;
    if (availW <= 0) return;
    // XXS(15スロット)がちょうど収まるサイズ
    mobileSlotPx = Math.floor(availW / 15);
    document.documentElement.style.setProperty('--mobile-slot-px', mobileSlotPx + 'px');
  }

  function applyBraceletZoom() {
    const scrollEl = dom.bracelet.parentElement; // .cs-bracelet-scroll
    if (window.matchMedia('(max-width: 749px)').matches) {
      // モバイル: zoom なし（タッチD&Dの座標ずれを防ぐ）
      // スクロールエリアのパディングをスロットサイズに比例して設定
      dom.bracelet.style.zoom      = '';
      const sp = mobileSlotPx;
      scrollEl.style.paddingTop    = (Math.round(sp * 2.7) + 10) + 'px';
      scrollEl.style.paddingBottom = (Math.round(sp * 4.0) + 10) + 'px';
      return;
    }
    const slotPx = 72;
    const braceW = currentSize * slotPx;
    const availW = scrollEl.clientWidth - 32; // 左右パディング各16px除く
    if (availW <= 0) return;

    const scale = Math.min(1, availW / braceW);
    dom.bracelet.style.zoom = scale < 1 ? String(scale) : '';

    // ウォッチ上部（最大180px）・ダングル下部のオーバーフロー領域をスケールに合わせて調整
    const topPad = Math.round(190 * scale) + 10;
    const botPad = Math.round(210 * scale) + 10;
    scrollEl.style.paddingTop    = topPad + 'px';
    scrollEl.style.paddingBottom = botPad + 'px';
  }

  function showOverview() {
    const overviewScroll = dom.overviewScroll;
    if (!overviewScroll) return;

    // ブレスレットをズームしてモーダルに表示
    // availW: モーダルの box (max 480px) からパディング 32px 分を引いた幅
    const boxW  = Math.min(window.innerWidth - 32, 480) - 32;
    const sp    = mobileSlotPx;
    const braceW = currentSize * sp;
    const scale  = Math.min(1, boxW / braceW);

    const clone = dom.bracelet.cloneNode(true);
    clone.style.pointerEvents = 'none';
    clone.style.zoom = String(scale);

    // スロット高さに比例したパディングで時計・ダングルのはみ出しを確保
    const topPad = Math.round(sp * 2.7 * scale) + 10;
    const botPad = Math.round(sp * 4.0 * scale) + 10;
    overviewScroll.style.padding = topPad + 'px 0 ' + botPad + 'px';
    overviewScroll.innerHTML = '';
    overviewScroll.appendChild(clone);

    dom.overviewModal.hidden = false;
  }

  function closeOverview() {
    dom.overviewModal.hidden = true;
  }

  function syncFromDOM() {
    const newSlots = [];
    dom.bracelet.querySelectorAll('.cs-slot').forEach(el => {
      const id = el.dataset.charmId;
      const n  = parseInt(el.dataset.slots || '1');
      if (id) {
        const charm = allCharms.find(c => String(c.id) === id);
        for (let i = 0; i < n; i++) newSlots.push(charm || null);
      } else {
        newSlots.push(null);
      }
    });
    slots = newSlots;
  }

  // 配置済みチャームをすき間なく左詰めにする
  function compactSlots() {
    const placed = getPlacedCharms();
    slots = Array(currentSize).fill(null);
    let idx = 0;
    for (const charm of placed) {
      const n = charm.slots;
      if (idx + n <= currentSize) {
        for (let i = 0; i < n; i++) slots[idx + i] = charm;
        idx += n;
      }
    }
  }

  function removeCharmFromSlot(slotEl) {
    syncFromDOM();
    const domEls = [...dom.bracelet.querySelectorAll('.cs-slot')];
    const domIdx = domEls.indexOf(slotEl);
    const n = parseInt(slotEl.dataset.slots || '1');

    // DOM要素のインデックス → スロット配列のインデックスを計算
    let slotIdx = 0;
    for (let i = 0; i < domIdx; i++) {
      const d = domEls[i];
      slotIdx += d.dataset.charmId ? parseInt(d.dataset.slots || '1') : 1;
    }

    for (let i = 0; i < n; i++) {
      if (slotIdx + i < slots.length) slots[slotIdx + i] = null;
    }

    compactSlots();
    renderBracelet();
    updateMeta();
  }

  /* ── カウント・カートバー ─────────────── */

  function updateMeta() {
    const filled = slots.filter(Boolean).length;
    dom.countLabel.textContent = `${filled} / ${currentSize} スロット使用中`;
    dom.cartBar.hidden = filled === 0;
  }

  /* ── カテゴリ ────────────────────────── */

  function renderCategories() {
    const cats = [...new Set(
      allCharms.flatMap(c =>
        c.tags
          .filter(t => t.startsWith(CAT_PREFIX))
          .map(t => t.slice(CAT_PREFIX.length))
      )
    )].sort();

    dom.cats.innerHTML = [
      `<button class="cs-cat-btn cs-cat-btn--active" data-cat="all">すべて</button>`,
      ...cats.map(c => `<button class="cs-cat-btn" data-cat="${c}">${c}</button>`)
    ].join('');

    dom.cats.querySelectorAll('.cs-cat-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        dom.cats.querySelectorAll('.cs-cat-btn').forEach(b => b.classList.remove('cs-cat-btn--active'));
        btn.classList.add('cs-cat-btn--active');
        activeCategory = btn.dataset.cat;
        renderCatalog();
      });
    });
  }

  /* ── カタログ ────────────────────────── */

  function renderCatalog() {
    const list = activeCategory === 'all'
      ? allCharms
      : allCharms.filter(c => c.tags.includes(CAT_PREFIX + activeCategory));

    dom.catalog.innerHTML = list.length
      ? list.map(c =>
          `<div class="cs-charm-card" data-id="${c.id}">
            <img src="${c.image}" alt="${c.title}" loading="lazy">
            <span class="cs-charm-name">${c.title}</span>
            <span class="cs-charm-price">${c.priceFormatted}</span>
            ${c.slots > 1 ? `<span class="cs-charm-slots">${c.slots}スロット</span>` : ''}
          </div>`
        ).join('')
      : `<p class="cs-empty-msg">このカテゴリにチャームはありません</p>`;

    dom.catalog.querySelectorAll('.cs-charm-card').forEach(card => {
      card.addEventListener('click', () => {
        const charm = allCharms.find(c => String(c.id) === card.dataset.id);
        if (charm) addCharm(charm);
      });
    });
  }

  /* ── チャームを追加 ──────────────────── */

  function findConsecutiveEmpty(n) {
    for (let i = 0; i <= slots.length - n; i++) {
      if (slots.slice(i, i + n).every(s => s === null)) return i;
    }
    return -1;
  }

  function addCharm(charm) {
    const n = charm.slots;
    const startIdx = findConsecutiveEmpty(n);
    if (startIdx === -1) {
      alert(n > 1
        ? `連続した空きスロットが${n}個必要です。スロットを空けるか、サイズを変えてください。`
        : 'スロットがいっぱいです。×ボタンでチャームを外すか、サイズを変えてください。'
      );
      return;
    }
    for (let i = 0; i < n; i++) slots[startIdx + i] = charm;
    renderBracelet();
    updateMeta();
  }

  /* ── 配置済みチャーム一覧（重複なし）── */

  function getPlacedCharms() {
    const list = [];
    let i = 0;
    while (i < slots.length) {
      const charm = slots[i];
      if (!charm) { i++; continue; }
      list.push(charm);
      i += charm.slots;
    }
    return list;
  }

  /* ── カートに追加 ────────────────────── */

  async function addToCart() {
    const items = getPlacedCharms().map(c => ({ id: c.variantId, quantity: 1 }));
    if (!items.length) return;

    dom.cartBtn.disabled = true;
    dom.cartBtn.textContent = '追加中…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error();
      window.location.href = '/cart';
    } catch {
      alert('カートへの追加に失敗しました。もう一度お試しください。');
      dom.cartBtn.disabled = false;
      dom.cartBtn.textContent = 'カートに追加';
    }
  }

  /* ── 初期化 ──────────────────────────── */

  if (dom.overviewBtn)   dom.overviewBtn.addEventListener('click', showOverview);
  if (dom.overviewClose) dom.overviewClose.addEventListener('click', closeOverview);
  if (dom.overviewBd)    dom.overviewBd.addEventListener('click', closeOverview);

  dom.reset.addEventListener('click', () => {
    slots = Array(currentSize).fill(null);
    renderBracelet();
    updateMeta();
  });

  dom.cartBtn.addEventListener('click', addToCart);

  let _resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(_resizeTimer);
    _resizeTimer = setTimeout(() => {
      if (window.matchMedia('(max-width: 749px)').matches) {
        const prev = mobileSlotPx;
        updateMobileSlotSize();
        if (mobileSlotPx !== prev) {
          // 画面幅が変化（横向き切替など）→ 再レンダリング
          renderBracelet();
          updateMeta();
          return;
        }
      }
      applyBraceletZoom();
    }, 150);
  });

  renderSizes();
  renderCategories();
  renderCatalog();

})();
